import React from 'react';

import Payments from './Payments';

function PaymentsContainer() {
  const [step, setStep] = React.useState(0);
  return <Payments onStepSet={setStep} step={step} />;
}

export default PaymentsContainer;
